import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
function Banner({ iconComponent, description }) {
    return (_jsx(Box, { clone: true, pt: 2, pr: 1, pb: 1, pl: 2, children: _jsx(Paper, { elevation: 0, children: _jsxs(Grid, { container: true, spacing: 2, alignItems: "center", wrap: "nowrap", children: [iconComponent && (_jsx(Grid, { item: true, children: _jsx(Box, { bgcolor: "primary.main", clone: true, children: _jsx(Avatar, { children: iconComponent }) }) })), _jsx(Grid, { item: true, children: _jsx(Typography, { children: description }) })] }) }) }));
}
Banner.displayName = "DployBanner";
export { Banner };
//# sourceMappingURL=Banner.js.map